import React from 'react';

const AddItem = () => {
  return (
    <div className="p-6" dir="rtl">
      <h1 className="text-2xl font-semibold text-center text-gray-700 mb-12"></h1>
     
    </div>
  );
};

export default AddItem;
